//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
// import oloList from '../../assets/data/olo.json'

export default {
  props: {
    blok: {
      type: Object
    }
  },
  data() {
    return {
      placeholder: false
    }
  },
  computed: {
    ...mapState([ 'location', 'menu', 'product', 'options' ]),
  },
  methods: {
    getImage() {
      let image = ''
      if(this.product.data && this.product.data.images) {
        this.product.data.images.map(i => {
          if(this.location/* && oloList.indexOf(this.location.id) > -1*/) {
            if(i.groupname === 'marketplace-product') {
              image = this.menu.imagepath + i.filename
            }
          // } else {
          //   if(i.groupname == this.blok.imagename) {
          //     image = i.filename
          //   } else {
          //     image = this.product.data.images[0].filename
          //   }
          }
        })
      }
      if (image == '') {
        image = 'https://a.storyblok.com/f/127749/x/29ac74edf9/himself-approved-red.svg'
        this.placeholder = true
      }
      return image
    },
    titleCase(str) {
      return str.toLowerCase().replace(/\b(\w)/g, s => s.toUpperCase())
    }
  }
}
